import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { updateTenantGoogleAuthLogin } from "../../../../services/apiSystemSettings";
import useMutate from "../../../../hooks/useMutate";
import { useSettingsDirtyState } from "./useSettingsDirtyState";

export const googleAuthLoginSchema = yup.object().shape({
  google_login_enabled: yup.boolean().required(),
  google_workspace_domain: yup.string().nullable().when("google_login_enabled", {
    is: true,
    then: () =>
      yup
        .string()
        .trim()
        .matches(
          /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Enter a valid domain (e.g., sofmen.com)"
        )
        .required("Google Workspace domain is required"),
    otherwise: () => yup.string().nullable(),
  }),
});

export function useGoogleAuthLoginForm(initialData) {
  const methods = useForm({
    resolver: yupResolver(googleAuthLoginSchema),
    defaultValues: initialData,
  });
  const { mutate, isPending } = useMutate(updateTenantGoogleAuthLogin, [
    "logo",
    "tenant-details",
  ]);
  const { formValues, hasChanges } = useSettingsDirtyState(methods, initialData);

  const onSubmit = useCallback(
    (formData) => {
      mutate(formData);
    },
    [mutate]
  );

  return {
    methods,
    formValues,
    hasChanges,
    isPending,
    onSubmit,
  };
}
